if (!customElements.get('featured-slider')) {
  customElements.define(
    'featured-slider',
    class FeaturedSlider extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          slider: 'slider-component',
          featuredSlides: '[data-featured-slide]',
        };
        this.featuredSlides = this.querySelectorAll(this.selectors.featuredSlides);
        this.slider = this.querySelector(this.selectors.slider);
        this.currentPage = 1;

        this.slider.addEventListener('slideChanged', ({ detail }) => {
          const targetId = window.matchMedia('(min-width: 750px)').matches
            ? detail.currentElement.previousSibling.id
            : detail.currentElement.id;
          this.featuredSlides.forEach((slide) => {
            if (targetId === slide.dataset.id) {
              slide.classList.add('featured');
              if (detail.currentPage < this.currentPage) {
                slide.classList.add('animate-slide-in-from-left');
              } else {
                slide.classList.add('animate-slide-in-from-right');
              }
            } else {
              slide.classList.remove('featured', 'animate-slide-in-from-right', 'animate-slide-in-from-left');
            }
          });

          this.currentPage = detail.currentPage;
        });
      }
    }
  );
}
